import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

/**
 * A registration's Status is the SUPPLIER'S answer, and nothing else. Whether
 * its email went is the Delivery column's (registrationEmail.deliveryState),
 * which the server sets -- so there is no Ready to Send / Sent / Unsent here
 * to disagree with it.
 *
 * ⚠ The ids are the server's (its OpportunityRegistrationStatus table).
 * SUBMITTED is 2, the old "Sent", relabelled; Rejected and Approved keep 4 and
 * 5. The server drops the old 1 (Ready to Send), 3 (Unsent) and 6 (Under
 * Review), and its existing rows on those become 2.
 */
export enum OpportunityRegistrationStatusIds {
  SUBMITTED = 2,
  REJECTED = 4,
  APPROVED = 5,
}

export function getOpportunityRegistrationStatii(): ISelectItem[] {
  return [
    { id: OpportunityRegistrationStatusIds.SUBMITTED, label: 'Submitted' },
    { id: OpportunityRegistrationStatusIds.APPROVED, label: 'Approved' },
    { id: OpportunityRegistrationStatusIds.REJECTED, label: 'Rejected' },
  ]
}

export const getOpportunityRegistrationStatusByLabel = getItemByLabelFactory(
  getOpportunityRegistrationStatii
)

export const getOpportunityRegistrationStatusById = getItemByIdFactory(
  getOpportunityRegistrationStatii
)
